
import {   IInsituPoint, IResult } from '../typings/api';
import { axiosInstance } from './Api';

export default class InsituPoint {
  endPoint = 'InSitu';

  async getInsituPoints() {
    try {
      const r = await axiosInstance.get<IResult<Array<IInsituPoint>>>(`/${this.endPoint}/GetPoints`);
      if (r.data.Error) {
        return undefined;
      }
      return r.data;
    } catch {
      return undefined;
    }
  }

  async getParametersInsitu() {
    try {
      const url = `/${this.endPoint}/GetParameters`
      const r = await axiosInstance.get(url);
      if (r.data.Error) {
        return [];
      }
      return r.data;
    } catch (error) {
      return [];
    }
  }
}
